<template>
  <a-modal
    title="刪除门店"
    :visible="visible"
    :confirm-loading="loading"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p>确定要删除这些门店吗？</p>
  </a-modal>
</template>

<script>
import { shopDelete } from '@/api/shop'

export default {
  props: {
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      noticeTitle: '门店管理',
      visible: false,
      loading: false
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleOk() {
      this.loading = true
      setTimeout(() => {
        if (this.visible) {
          const shopIds = this.selectedRows
            .map(item => {
              return item.id
            })
            .join(',')
          const param = {
            shopIds
          }
          shopDelete(param)
            .then(res => {
              if (res.success) {
                this.visible = false
                this.$notification.success({
                  message: this.noticeTitle,
                  description: '门店删除成功！'
                })
                this.$emit('reload')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }, this.asyncTime)
    },
    handleCancel() {
      this.visible = false
      this.loading = false
    }
  }
}
</script>
